import { isToday, format, getTime, formatDistanceToNow, isWeekend, isSameDay, parseISO } from 'date-fns';
import { publicHolidays } from './config';

// ----------------------------------------------------------------------

export function fDate(date: Date | string | null | undefined, newFormat?: string): string {
	const fm = newFormat || 'dd MMM yyyy';
	return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date: Date | string | null | undefined, newFormat?: string): string {
	const fm = newFormat || 'dd MMM yyyy p';
	return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date: Date | string | null | undefined): number | string {
	return date ? getTime(new Date(date)) : '';
}

export function fToNow(date: Date | string | null | undefined): string {
	return date
		? formatDistanceToNow(new Date(date), {
				addSuffix: true,
			})
		: '';
}

export function fIsToday(date: Date | string | null | undefined): boolean {
	return date ? isToday(new Date(date)) : false;
}

export function fIsWeekend(date: Date | string | null | undefined): boolean {
	return date ? isWeekend(new Date(date)) : false;
}

export function fIsPublicHoliday(date: Date) {
	return publicHolidays.some((holiday) => {
		return isSameDay(date, parseISO(holiday));
	});
}

export function fIsValidDate(date: unknown): boolean {
	return date instanceof Date && !Number.isNaN(date.getTime());
}
